import { render, staticRenderFns } from "./TextWithImageGallery.vue?vue&type=template&id=7ceed0c2"
import script from "./TextWithImageGallery.vue?vue&type=script&lang=js"
export * from "./TextWithImageGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports